(function () {
  var mq = window.matchMedia('(max-width: 989px)');
  var touch = window.matchMedia('(hover: none)');

  function watchFooter(bar, isWanted) {
    var footer = document.querySelector('footer');
    var footerIn = false;
    function sync() { bar.classList.toggle('is-on', mq.matches && isWanted() && !footerIn); }
    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { footerIn = e[0].isIntersecting; sync(); }, { rootMargin: '0px 0px -40px 0px' }).observe(footer);
    }
    return sync;
  }

  function productBar() {
    var root = document.querySelector('.ftp');
    var buy = root && root.querySelector('[data-ftp-buy]');
    if (!buy) return;
    var title = root.querySelector('.ftp__title');
    var price = root.querySelector('[data-ftp-price]');
    var form = root.querySelector('form');
    var bar = document.createElement('div');
    bar.className = 'fm-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Ajout rapide au panier');
    bar.innerHTML = '<button type="button" class="fm-bar__info" data-fm-edit><span class="fm-bar__price" data-fm-price></span><span class="fm-bar__var" data-fm-var></span></button><button type="button" class="fm-bar__btn" data-fm-buy></button>';
    document.body.appendChild(bar);
    var bPrice = bar.querySelector('[data-fm-price]');
    var bVar = bar.querySelector('[data-fm-var]');
    var bBuy = bar.querySelector('[data-fm-buy]');
    var edit = bar.querySelector('[data-fm-edit]');

    function refresh() {
      bPrice.textContent = price ? price.textContent : '';
      var parts = [];
      root.querySelectorAll('[data-ftp-chosen]').forEach(function (c) { if (c.textContent.trim()) parts.push(c.textContent.trim()); });
      bVar.textContent = parts.length ? parts.join(' · ') : (title ? title.textContent : '');
      edit.setAttribute('aria-label', 'Modifier la taille ou la couleur : ' + bVar.textContent);
      bBuy.disabled = buy.disabled;
      bBuy.textContent = buy.disabled ? buy.textContent : 'Ajouter au panier';
    }
    refresh();
    root.addEventListener('change', function () { setTimeout(refresh, 0); });
    if (price) new MutationObserver(refresh).observe(price, { childList: true, characterData: true, subtree: true });
    new MutationObserver(refresh).observe(buy, { attributes: true, childList: true });

    bBuy.addEventListener('click', function () { if (!buy.disabled) buy.click(); });
    edit.addEventListener('click', function () {
      var target = (form && form.querySelector('fieldset')) || form || buy;
      var top = target.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });

    var past = false;
    var sync = watchFooter(bar, function () { return past; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        past = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
        sync();
      }).observe(buy);
    }
    mq.addEventListener && mq.addEventListener('change', sync);
  }

  function homeBar() {
    var bar = document.querySelector('[data-fm-home]');
    if (!bar) return;
    document.body.appendChild(bar);
    bar.hidden = false;
    var scrolled = false;
    var sync = watchFooter(bar, function () { return scrolled; });
    function onScroll() {
      var s = window.pageYOffset > window.innerHeight * 0.9;
      if (s !== scrolled) { scrolled = s; sync(); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    mq.addEventListener && mq.addEventListener('change', sync);
  }

  function touchGallery() {
    if (!touch.matches) return;
    document.querySelectorAll('[data-fpv-media]').forEach(function (box) {
      var imgs = [].slice.call(box.querySelectorAll('.fpv__img'));
      var bars = [].slice.call(box.querySelectorAll('.fpv__bars i'));
      if (imgs.length < 2) return;
      var cur = 0, timer = null, swiped = false, x0 = 0, y0 = 0;
      function show(i) {
        cur = (i + imgs.length) % imgs.length;
        imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === cur); });
        bars.forEach(function (b, k) { b.classList.toggle('is-on', k === cur); });
      }
      function play() { stop(); timer = setInterval(function () { show(cur + 1); }, 2800); }
      function stop() { if (timer) clearInterval(timer); timer = null; }
      box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; swiped = false; }, { passive: true });
      box.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { swiped = true; show(cur + (dx < 0 ? 1 : -1)); play(); }
      }, { passive: true });
      box.addEventListener('click', function (e) { if (swiped) { e.preventDefault(); swiped = false; } });
      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        new IntersectionObserver(function (e) { if (e[0].isIntersecting) play(); else stop(); }, { threshold: 0.5 }).observe(box);
      }
    });
  }

  function init() { productBar(); homeBar(); touchGallery(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
